/**
 * Web Navigation Adapter
 * Adapts react-router-dom to work with screens expecting React Navigation props
 */

import { useNavigate, useLocation, useParams } from 'react-router-dom';

export const useWebNavigation = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const params = useParams();

  return {
    navigation: {
      navigate: (screen, params) => {
        const routes = {
          'Login': '/',
          'Register': '/register',
          'EmailVerification': '/email-verification',
          'Subscription': '/subscription',
          'ForgotPassword': '/forgot-password',
          'MainTabs': '/home',
          'Home': '/home',
          'Charts': '/charts',
          'Trades': '/trades',
          'History': '/history',
          'Profile': '/profile',
          'Setting': '/settings',
          'Wallet': '/wallet',
          'Referral': '/referral',
          'WithdrawalReferral': '/withdrawal-referral',
          'WithdrawalReferralScreen': '/withdrawal-referral',
          'Deposit': '/deposit',
          'Withdrawal': '/withdrawal',
          'EditProfile': '/edit-profile',
          'ChangePassword': '/change-password',
          'HelpSupport': '/help',
          'Terms': '/terms',
          'Privacy': '/privacy',
          'About': '/about',
        };

        const path = routes[screen] || `/${screen.toLowerCase()}`;
        navigate(path, { state: params });
      },
      goBack: () => navigate(-1),
      replace: (screen, params) => {
        const routes = {
          'Login': '/',
          'MainTabs': '/home',
          'Home': '/home',
        };
        const path = routes[screen] || `/${screen.toLowerCase()}`;
        navigate(path, { replace: true, state: params });
      },
      push: (screen, params) => {
        navigate(`/${screen.toLowerCase()}`, { state: params });
      },
      setOptions: () => {}, // No-op for web
    },
    route: {
      params: location.state || params || {},
      name: location.pathname,
    },
  };
};
